var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.modalId,"hide-footer":""},on:{"close":_vm.closeModal}},[_c('b-card',{attrs:{"title":_vm.heading}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }